export default [
  {
    name: 'Seo.MetaPages',
    path: 'metapages',
    component: () => import('./components/metaPages/List')
  },
  {
    name: 'Seo.MetaPages.Edit',
    path: 'metapages/:id?/edit',
    props: true,
    component: () => import('./components/metaPages/Edit')
  },
  {
    name: 'Seo.FaqGroups',
    path: 'faqgroups',
    component: () => import('./components/faqGroups/List')
  },
  {
    name: 'Seo.FaqGroups.Edit',
    path: 'faqgroups/:id?/edit',
    props: true,
    component: () => import('./components/faqGroups/Edit')
  },
  {
    name: 'Seo.Faq',
    path: 'faq',
    component: () => import('./components/faq/List')
  },
  {
    name: 'Seo.Faq.Edit',
    path: 'faq/:id?/edit',
    props: true,
    component: () => import('./components/faq/Edit')
  },
  {
    name: 'Seo.Categories',
    path: 'blogcategories',
    component: () => import('./components/categories/List')
  },
  {
    name: 'Seo.Categories.Edit',
    path: 'blogcategories/:id?/edit',
    props: true,
    component: () => import('./components/categories/Edit')
  },
  {
    name: 'Seo.Banners',
    path: 'banners',
    component: () => import('./components/banners/List')
  },
  {
    name: 'Seo.Banners.Edit',
    path: 'banners/:id?/edit',
    props: true,
    component: () => import('./components/banners/Edit')
  },
  {
    name: 'Seo.Blog',
    path: 'blog',
    component: () => import('./components/blog/List')
  },
  {
    name: 'Seo.Blog.Edit',
    path: 'blog/:id?/edit',
    props: true,
    component: () => import('./components/blog/Edit')
  }
]
